import { red } from "@material-ui/core/colors";
import { createTheme } from "@material-ui/core/styles";
import transitions from "@material-ui/core/styles/transitions";

// A custom theme for this app
const theme = createTheme({
  palette: {
    type: "light",
    primary: {
      main: "#61dafb",
      light: "#61dafb",
      dark: "#21a1c4"
    },
    secondary: {
      main: "#b5ecfb",
      light: "#61dafb",
      dark: "#21a1c4"
    },
    error: {
      main: red.A400
    },
    background: {
      default: "#282c34"
    }
  },
  props: {
    MuiButtonBase: {
      // disableRipple: true
    }
  },
  transitions: {
    // create: () => "none"
  }
  // overrides: {
  //   MuiPaper: {
  //     root: {
  //       padding: "20px 10px",
  //       margin: "10px",
  //       backgroundColor: "#fff", // 5d737e
  //     },
  //   },
  //   MuiButton: {
  //     root: {
  //       margin: "5px",
  //     },
  //   },
  // },
});
export default theme;
